// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Gv-z","summaryPar":"Hv-z","ratingCategories":"Iv-z","reviewerInfo":"Jv-z","reviewTypes":"Kv-z","expanded":"Lv-z"};